import { styled } from 'baseui'

export const Toolbar = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  flexWrap: 'wrap',
  marginBottom: '1.5rem',
})

export const SearchWrapper = styled('div', {
  flex: '1 1 20rem',
  maxWidth: '28rem',
})

export const searchInputOverrides = {
  Root: {
    style: ({ $theme }: { $theme: { borders: { radius200: string } } }) => ({
      borderTopLeftRadius: $theme.borders.radius200,
      borderTopRightRadius: $theme.borders.radius200,
      borderBottomRightRadius: $theme.borders.radius200,
      borderBottomLeftRadius: $theme.borders.radius200,
    }),
  },
  StartEnhancer: {
    style: { paddingLeft: '0.5rem', paddingRight: '0.25rem' },
  },
}
